const getTrackingCurrentStatusStyles = theme => ({
  color: theme.palette.gray.main
});

export { getTrackingCurrentStatusStyles };
//# sourceMappingURL=TrackingCurrentStatusStyles.js.map
